import React, { useEffect, useState } from 'react';
import { io } from 'socket.io-client';

const API_BASE = process.env.REACT_APP_HOSTNAME;

const ProgressTracker = ({ isProcessing }) => {
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isProcessing) {
      setProgress(0);
      setStatus('');
      setError(null);
      return;
    }

    const socket = io(API_BASE);

    
    socket.on('progress', (data) => {
      setProgress(data.progress);
      setStatus(data.status);
      setError(null);
    });

    socket.on('error', (data) => {
      setError(data.error);
      setProgress(0);
      setStatus('Error');
    });

    return () => {
      socket.disconnect();
    };
  }, [isProcessing]);

  if (!isProcessing) return null;

  return (
    <div className="w-full max-w-md mx-auto mt-4 p-4 bg-white rounded-lg shadow-md">
      <div className="mb-2 flex justify-between items-center">
        <span className="text-sm font-medium text-gray-700">{status}</span>
        <span className="text-sm font-medium text-gray-700">{progress}%</span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2.5">
        <div
          className="bg-blue-600 h-2.5 rounded-full transition-all duration-300"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
      {error && (
        <div className="mt-2 text-sm text-red-600">
          Error: {error}
        </div>
      )}
    </div>
  );
};

export default ProgressTracker; 